import { computePosition, autoUpdate, flip, shift, offset } from '@floating-ui/dom';

const popoverButtons = document.querySelectorAll('.js-btn-popover');

// Function to position the popover
function positionPopover(button, popover) {
    computePosition(button, popover, {
        placement: 'bottom',
        middleware: [flip(), shift({ padding: 5 }), offset(6)],
    }).then(({ x, y }) => {
        Object.assign(popover.style, {
            left: `${x}px`,
            top: `${y}px`,
        });
    });
}

// Hide all popovers
function hidePopovers() {
    document.querySelectorAll('[popover]').forEach((popover) => {
        popover.hidePopover();
    });
}

// Position all popovers on load
popoverButtons.forEach((button) => {
    const target = button.getAttribute('popovertarget');
    const popover = document.querySelector('#' + target);
    positionPopover(button, popover);
});

document.addEventListener('DOMContentLoaded', function () {
    // Position and show popover on click
    popoverButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const target = button.getAttribute('popovertarget');
            const popover = document.querySelector('#' + target);

            // Show the popover first
            popover.showPopover();
            // Then compute it's position
            positionPopover(button, popover);
        });
    });

    // Hide popovers on scroll
    window.addEventListener('scroll', hidePopovers);
});
